import { useContext } from 'react';
import { CatalystsContext } from '../components/context/catalysts-context';
export const useCatalysts = () => useContext(CatalystsContext);